import React, {Component} from 'react'
import Form from "./form/Form";

export default class ItemSelectModal extends Component
{
    constructor(props)
    {
        super(props);

        let categories = this.categories();

        this.state = {
            ...this.state,
            isDisabled: props.disabled,
            categories,
            active: TB.first(categories)
        };
    }

    selectActiveCategory(categoryId) {
        // console.log('selectActiveCategory', categoryId)
        if (!categoryId) return;
        let category = TB.find(this.categories(), ['id', categoryId]);

        if (categoryId !== this.state.active?.id && category) {
            return this.setState({active:category})
        }
    }

    categories() {
        if (TB.isDefined(this.state?.categories) && this.state.categories.length) {
            return this.state.categories
        }

        let categories = {}, {fieldName, items} = this.props;
        let hasCategories = TB.find([...items], item => TB.isDefined(item.category));

        if(hasCategories) {
            TB.map([...this.props.items], item => {
                let catId = item.category.id;
                if(!categories[catId]) {
                    categories[catId] = {...item.category};
                    categories[catId][fieldName] = [];
                }

                categories[item.category.id][fieldName].push(item);
            });
            categories = TB.orderBy(TB.values(categories), 'display_index');

        } else {
            categories = [...items];
        }
        return categories;
    }

    mobileFields() {

        return [
            {
                style: styles.fieldSection,
                fields: {
                    activeId: {
                        type: 'select',
                        label: "Select a category",
                        options: TB.reduce(this.categories(), (options, category) => {
                            options.push({
                                label:category.name, value:category.id
                            })
                            return options
                        }, []),
                        style: styles.selectField
                    },
                    roleLabel: (
                        <div className="form-group mb-0 pb-4">
                            <label htmlFor="" className="col-form-label mb-0">
                                {this.props.itemHeader}s for:&nbsp;
                                <span className="text-primary">{this.state.active?.name}</span>
                            </label>
                        </div>
                    ),
                }
            }
        ]
    }
    render()
    {
        let {active} = this.state
        let {
            fieldName,
            multiSelect,
            selectedIds,
            isDisabled,
            categoryHeader,
            itemHeader
        } = this.props;

        let categories = this.categories();

        return (
            <div className="modal-table">
                <Form
                    ref="form"
                    className="default-form modal-category-form md:hidden"
                    onSubmit={console.warn}
                    submitButton={false}
                    background={'none'}
                    model={{activeId: active.id}}
                    onChange={({activeId}) => this.selectActiveCategory(activeId)}
                    fields={this.mobileFields()}
                />

                <div className="select-contents-header hidden md:flex">
                    <div className="cat-header header-section hidden md:flex">
                        <h3>
                            {categoryHeader}
                        </h3>
                    </div>
                    <div className="header-row">
                        <div className="item-header header-section">
                            <h3>
                                {itemHeader}
                            </h3>
                        </div>
                        <div className="content-header desc-section header-section hidde md:flex">
                            <h3>
                                Description
                            </h3>
                        </div>
                    </div>

                </div>

                <div className="select-contents-container">
                    <div className="select-contents-nav hidden md:flex">
                        {categories.length > 0 && TB.map(categories, (category, index) => {
                            return (
                                <div
                                    key={`${fieldName}-cat-${index}`}
                                    onClick={this.selectActiveCategory.bind(this, category.id)}
                                    className={TB.mapClass({
                                        'select-content-nav-item': true,
                                        'active': (!isDisabled && category.id === active.id)
                                    })}>
                                    <p>
                                        <span>{category.name}</span>
                                        <i className="fas fa-caret-right"/>
                                    </p>
                                </div>
                            );
                        })}
                    </div>
                    {active && (
                        <div className="modal-category-container">
                            <div className="category-items">
                                {active[fieldName].map(
                                    item => this.renderItem(item)
                                )}
                            </div>

                        </div>
                    )}
                </div>
                <div className="my-3 px-1 flex flex-row items-center justify-end">
                    <button className="btn btn-primary" onClick={() => this.props.hideModal()}>
                        Close
                    </button>
                </div>
            </div>
        )
    }


    renderItem(item) {

        let {
            fieldName,
            multiSelect,
            selectedIds,
            isDisabled,
        } = this.props;
        return (
            <div className="item-section"
                 key={`${fieldName}-${item.id}`}>

                <div className={"item-row"}>
                    <div className={TB.mapClass({
                        "item-info":true,
                        "selected-item": multiSelect && selectedIds.includes(item.id)
                    })}>
                        <h3 className="item-name">
                            {item.name}
                        </h3>
                        <p className="item-description py-2 flex sm:hidden">
                            {item.description}
                        </p>

                        {multiSelect ? (
                            <div className={"form-checkbox"}>

                                <input type="checkbox"
                                       disabled={isDisabled}
                                       className="form-check-input"
                                       id={`${TB.singularize(fieldName)}[${item.id}]`}
                                       name={`${TB.singularize(fieldName)}[${item.id}]`}
                                       onChange={event => this.props.toggleItem(item)}
                                       checked={selectedIds.includes(item.id)}/>

                                <label className="form-check-label" htmlFor={`${TB.singularize(fieldName)}[${item.id}]`}>

                                    <p className="btn-form-modal">
                                        Select
                                    </p>
                                </label>
                            </div>
                        ) : (
                            !selectedIds?.includes(item.id) && (
                                <p className={'btn-form-modal'} onClick={() => this.props.onSelectItem(item)}>
                                    {this.props.selectText}
                                </p>
                            )
                        )}

                    </div>
                    <div className="item-info active-section hidden md:flex">
                        <p className="item-description">
                            {item.description}
                        </p>
                    </div>
                </div>
            </div>
        )
    }

}
const styles = {
    selectField: {
        flexBasis: 'unset!important'
    },
    startBtn: {
        flexGrow: 'unset',
        marginLeft: 15,
        minWidth: 'unset'
    },
    fieldSection: {
        flexDirection: 'row'
    },
    field: {
        padding: '0 15px',
    },
}